
export const Form_DATA_REQ = "formdata/req";
export const FORM_DATA_SUCCESS = "formdata/success";
export const FORM_DATA_FAILED = "formdata/failed";




export const GET_DATA_REQ = "getdata/req";
export const GET_DATA_SUCCESS = "getdata/success";
export const GET_DATA_FAILED = "getdata/failed";